/* eslint-disable max-len */
import 'react';

const CopyLinkSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_32093_23520" style={{'maskType': 'alpha'}} maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                <rect width="18" height="18" fill="#D9D9D9" />
            </mask>
            <g mask="url(#mask0_32093_23520)">
                <path d="M12.2884 9.14737L14.1567 7.14858C15.1057 6.13335 15.0397 4.55443 14.0093 3.62197V3.62197C12.9789 2.68951 11.3743 2.7566 10.4253 3.77183L8.14272 6.21375C7.03539 7.39838 7.11243 9.24077 8.31478 10.3288L8.6375 10.6209" stroke="#3377FF" strokeWidth="1.125" strokeLinecap="round" />
                <path d="M5.87133 9.60298L3.91731 11.5256C2.92739 12.4996 2.92739 14.0788 3.91731 15.0528V15.0528C4.90723 16.0268 6.5122 16.0268 7.50212 15.0528L9.89023 12.7031C11.0461 11.5658 11.0461 9.72183 9.89023 8.58452L9.58161 8.28086" stroke="#3377FF" strokeWidth="1.125" strokeLinecap="round" />
            </g>
        </svg>
    );
};
export default CopyLinkSvg;
